import { fetcher } from '@commenda/utils';

async function markMailAsRead(mailId: string) {
  const url = `mailroom/mails/${mailId}/mark-as-read`;

  const response = await fetcher(url, { method: 'POST' });

  return response;
}

export { markMailAsRead };
